<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-12">
                    <h3 class="mb-0 text-uppercase">{{ $t('cohorts.platform-users') }}</h3>
                </div>
            </div>
        </div>

        <div>
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="ctrl.rows">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <span class="avatar rounded-circle">
                            <img :src="row.avatar">
                        </span>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row.name }}
                        </h4>
                        <small v-if="row.owner">
                            {{ row.owner.name }}
                        </small>
                        <small v-if="row.entity">
                            / {{ row.entity.name }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions">
                    <template v-slot="{row}">

                        <button-checkbox button-classes="btn-secondary btn-sm mb-1 mt-1" class="d-inline"
                                :value="row.learner || row.instructor" @change="addMember(row)">
                            {{ buttonLabel(row) }}
                        </button-checkbox>

                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import UserMapping from '../users/UserMapping'

    export default {

        props: {
            cohort: {
                type: Object,
                required: true
            },
        },

        data() {
            let mapping = new UserMapping()
            return {
                loaded: false,
                mapping,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/users',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    paging: {
                        perPage: 10,
                        total: 0
                    },
                    query: {
                        sort: ['lastname'],
                        relations: ['owner', 'entity'],
                        accessors: ['permissions'],
                        filters: {
                            active: true,
                            $or: [
                                { learner: true },
                                { instructor: true },
                                { admin: true }
                            ]
                        }
                    }
                }),
                search: '',
            }
        },

        computed: {
            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            }
        },

        created() {
            this.ctrl.mapData = this.mapData
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.$emit('ready')
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ simpleSearch: val })
            },

            cohort(val) {
                this.ctrl.rows.forEach(row => {
                    row.learner = this.isLearner(row)
                    row.instructor = this.isInstructor(row)
                });
            }
        },

        methods: {
            mapData(user) {
                let row = this.mapping.mapData(user)
                row.learner = this.isLearner(user)
                row.instructor = this.isInstructor(user)
                return row
            },

            buttonLabel(user) {
                if (user.learner) {
                    return this.$t('common.learner')
                }
                if (user.instructor) {
                    return this.$t('common.instructor')
                }
                return this.$t('common.enroll')
            },

            isLearner(user) {
                return this.cohort.members.find(member => member.id == user.id && member.pivot.role == 'learner') != undefined
            },

            isInstructor(user) {
                return this.cohort.members.find(member => member.id == user.id && member.pivot.role == 'instructor') != undefined
            },

            addMember(user) {
                if (user.learner || user.instructor) {
                    return
                }
                const role = user.permissions.includes('dashboard.access-learner-dashboard') ? 'learner' : 'instructor'
                axios.post('/astral/api/front/cohorts/'+this.$route.params.id+'/members/'+user.id, {
                    role: role
                })
                .then(resp => {
                    this.$emit('change');
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }
    .card >>> .table-control form {
        width: 100%;
    }
    
</style>
